import { render, staticRenderFns } from "./AddEditProduct.vue?vue&type=template&id=2a610f62"
import script from "./AddEditProduct.vue?vue&type=script&lang=js"
export * from "./AddEditProduct.vue?vue&type=script&lang=js"
import style0 from "./AddEditProduct.vue?vue&type=style&index=0&id=2a610f62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports